import ServiceRequestsCSVUploader from 'src/modules/ambient_solo/components/ServiceRequestsCSV/ServiceRequestsCSVUploader';
import { Button, Table, Spin, List } from 'antd';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  UploadOutlined,
  LoadingOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
// import './EncounterCSVUpload.scss';
import { showToastSuccess } from 'src/utilities/toast';
import { Modal } from 'antd';
import { downloadCSVAction } from 'src/store/actions/appointment.action';
import { csvDownloadUrlSlice } from 'src/store/slices/appointments.slice';
import { getBulkServiceRequestUploadHistory } from 'src/modules/SuperAdmin/store/actions/service_request';

const ServiceRequestsCSVUpload = () => {
  const dispatch = useDispatch();
  const { srBulkUploadHistory, srBulkUploadHistoryLoading } = useSelector(
    (state) => state?.serviceRequestState
  );
  const { csvDownloadUrl } = useSelector((state) => state?.appointmentState);
  const [showUpload, setShowUpload] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    per_page: 4,
  });
  const [s3Key, setS3Key] = useState('');
  const [downloadVisible, setDownloadVisible] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);
  const [verboseErrors, setVerboseErrors] = useState([]);

  useEffect(() => {
    dispatch(
      getBulkServiceRequestUploadHistory(
        pagination.current,
        pagination.per_page
      )
    );
  }, [pagination]);

  useEffect(() => {
    if (csvDownloadUrl && s3Key) {
      const link = document.createElement('a');
      link.href = csvDownloadUrl;
      link.download = s3Key.split('/').pop();
      document.body.appendChild(link);
      link.click();
      link.remove();
      setS3Key('');
      dispatch(csvDownloadUrlSlice(null));
    }
  }, [csvDownloadUrl]);

  const handlePageChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const handleViewDetails = (record) => {
    setVerboseErrors(record.verbose_errors);
    setDetailsVisible(true);
  };

  const columns = [
    {
      title: 'Upload date',
      dataIndex: 'created_at',
      key: 'created_at',
      width: '33.33%',
      render: (text, record) => (
        // show moment.utc({record.created_at}).local().format('MMM D, YYYY h:mm A') with an hyperlink to the s3_key if exists, else just show plain moment.utc({record.created_at}).local().format('MMM D, YYYY h:mm A')
        <>
          {record.s3_key && record.s3_key !== '' ? (
            <Link
              to="#"
              onClick={() => {
                setS3Key(record.s3_key);
                setDownloadVisible(true);
              }}
              className="hyperlink-style"
            >
              {moment
                .utc(record.created_at)
                .local()
                .format('MMM D, YYYY h:mm A')}
            </Link>
          ) : (
            moment.utc(record.created_at).local().format('MMM D, YYYY h:mm A')
          )}
        </>
      ),
    },
    {
      title: 'Uploaded by',
      dataIndex: 'created_by',
      key: 'created_by',
      width: '33.33%',
    },
    {
      title: 'Upload status',
      key: 'status',
      width: '33.33%',
      render: (text, record) => (
        <div>
          {record.created + record.updated + record.skipped + record.unchanged >
          0 ? (
            <>
              <div className="text-green-500">Created: {record.created}</div>
              <div className="text-orange-500">Updated: {record.updated}</div>
              <div className="text-red-500">Skipped: {record.skipped}</div>
              <div className="text-gray-500">Unchanged: {record.unchanged}</div>
              {record.verbose_errors != null && record.skipped > 0 && (
                <>
                  <Button
                    className="details-button"
                    size="small"
                    type="primary"
                    onClick={() => handleViewDetails(record)}
                  >
                    View details
                  </Button>
                </>
              )}
            </>
          ) : (
            <Spin indicator={<LoadingOutlined spin />} size="large" />
          )}
        </div>
      ),
    },
  ];

  const downloadFileHandler = async () => {
    setDownloadVisible(false);
    try {
      showToastSuccess('Downloading file...');
      dispatch(downloadCSVAction({ s3_key: s3Key }));
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <>
      <div className="flex flex-row justify-end mt-4">
        <div className="flex justify-end gap-2">
          <Button
            className="ih-button-primary"
            onClick={() => {
              dispatch(
                getBulkServiceRequestUploadHistory(
                  pagination.current,
                  pagination.per_page
                )
              );
            }}
            size="large"
            key="refresh-history"
          >
            <div className="flex gap-1 pt-0.5">
              {srBulkUploadHistoryLoading ? (
                <SyncOutlined spin />
              ) : (
                <SyncOutlined />
              )}
              <span className="font-sans text-sm ml-1">Refresh history</span>
            </div>
          </Button>
          <div>
            <Button
              className="ih-button-primary"
              onClick={() => setShowUpload(true)}
              size="large"
              key="bulk-upload"
            >
              <div className="flex gap-1 pt-0.5">
                <UploadOutlined />
                <span className="font-sans text-sm ml-1">Bulk upload</span>
              </div>
            </Button>
          </div>
        </div>
      </div>
      <span style={{ position: 'absolute' }}>
        <ServiceRequestsCSVUploader
          visible={showUpload}
          setVisible={setShowUpload}
        />
      </span>
      <div className="mt-4">
        <Table
          className="encounter-history-table"
          loading={srBulkUploadHistoryLoading}
          dataSource={srBulkUploadHistory?.histories}
          columns={columns}
          rowKey={(record) => record.created_at}
          pagination={{
            total: srBulkUploadHistory?.total,
            pageSize: pagination.per_page,
            onChange: handlePageChange,
          }}
        />
      </div>
      <Modal
        open={detailsVisible}
        onCancel={() => setDetailsVisible(false)}
        footer={null}
        centered={true}
        width="50vw"
        title="Details"
        className="csv-uploader-history-modal"
        styles={{ body: { height: '600px', overflow: 'auto' } }}
      >
        <List
          size="small"
          dataSource={verboseErrors}
          renderItem={(item) => (
            <List.Item className="text-sm">{item}</List.Item>
          )}
        />
      </Modal>
      <Modal
        open={downloadVisible}
        closable={false}
        centered={true}
        styles={{ body: { height: '35px' } }}
        footer={[
          <div key="footer" className="flex justify-end gap-1">
            <button
              key="back"
              className="bg-[#A9A9A9] hover:bg-[#899499] text-white font-normal p-1 py-1 px-2 rounded-md focus:outline-none focus:shadow-outline"
              onClick={() => setDownloadVisible(false)}
            >
              Cancel
            </button>
            <button
              key="submit"
              className="bg-[#00D090] hover:bg-[#059669] text-white font-normal p-1 py-1 px-2 rounded-md focus:outline-none focus:shadow-outline"
              onClick={downloadFileHandler}
            >
              Download
            </button>
          </div>,
        ]}
      >
        <div>
          <p>Are you sure you want to download this file?</p>
        </div>
      </Modal>
    </>
  );
};

export default ServiceRequestsCSVUpload;
